import { createContext } from "react"
import { getTheme } from "../utilities/theme"
import { ThemeMode } from "../types"

const theme = getTheme("dark")

interface RootContextType {
    theme: typeof theme
    themeMode: ThemeMode
    setThemeMode: (value: ThemeMode) => void
    isScreenTooSmall: boolean
    isScreenWayTooSmall: boolean
}

const rootContextDefaultValue: RootContextType = {
    theme: theme,
    themeMode: "dark",
    setThemeMode: ()=>{},
    isScreenTooSmall: false,
    isScreenWayTooSmall: false
}

export const rootContext = createContext<RootContextType>(
    rootContextDefaultValue
)